import React from 'react';
import { creations } from '../data/creations';
export function CreationsGallery() {
  return <section aria-labelledby="creations-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-48" data-mp="lbu4bgr2aqp4">
      <div className="max-w-6xl mx-auto" data-id="element-49" data-mp="gczevvyla3w1">
        <div className="max-w-2xl mx-auto text-center" data-id="element-50" data-mp="gbo6tjy429z4">
          <p className="text-xs font-semibold tracking-[0.12em] text-coral-deep" data-id="element-51" data-mp="cc71qrmljeuh">
            IDEE DA REALIZZARE
          </p>
          <h2 id="creations-title" className="mt-3 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal text-balance" data-id="element-52" data-mp="7dm8xd9obxg2">
            Scopri cosa puoi creare{' '}
            <span className="italic font-medium text-coral-deep" data-id="element-53" data-mp="3trduu80clv0h">con questa tecnica</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-54" data-mp="3otu78hhrg5vv">
            Lasciati ispirare e immagina la tua prossima creazione.
          </p>
        </div>

        <ul className="mt-10 sm:mt-14 grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-6 sm:gap-y-8 lg:grid-cols-3" data-id="element-55" data-mp="3fsmjuugs8pgk">
          {creations.map(c => <li key={c.id} data-id="element-56" data-mp="1tkrcm8c6l6bf">
              <figure data-id="element-57" data-mp="1tkhnemyyn36s">
                <div className="aspect-[4/5] overflow-hidden rounded-[18px] bg-sand shadow-soft" data-id="element-58" data-mp="1yciu7tdd01pf">
                  <img src={c.src} alt={c.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-59" data-mp="1kl4cdpv6u6jy" />
                </div>
                <figcaption className="mt-3 text-center font-serif italic text-base sm:text-lg text-teal" data-id="element-60" data-mp="1onr6jxfc03kb">
                  {c.motif}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}